import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { ExperienceAnswersContext } from '#providers/experiences/Experience.context.ts';
import type { TExperienceAnswersContextValue } from '#providers/experiences/Experience.types.ts';

export const useExperienceAnswers = (): TExperienceAnswersContextValue =>
  useRequiredContext(
    ExperienceAnswersContext,
    'useExperienceAnswers is only available inside an ExperienceProvider',
  );
